module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_down_small-e1ef351c094ba14b6bfbd8e700023371.svg";